import { render, staticRenderFns } from "./TPassIconPoint.vue?vue&type=template&id=10c5e51c&"
import script from "./TPassIconPoint.vue?vue&type=script&lang=js&"
export * from "./TPassIconPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports